export default "__VITE_ASSET__gJIq4PVW__"